import { normalizeRsvpFeedbackTranslations, normalizeRsvpFeedbackLanguage, defaultRsvpWhatsAppFeedback, rsvpFeedbackMessageKey, rsvpWhatsAppAnswerText } from "./rsvpWhatsAppMessages.js";

export const RSVP_FEEDBACK_GROUPS = [
  {
    "key": "confirmed",
    "label": "Resposta com presença registrada"
  },
  {
    "key": "declined",
    "label": "Resposta sem presença registrada"
  },
  {
    "key": "changed_yes",
    "label": "Resposta alterada para uma opção com presença"
  },
  {
    "key": "changed_no",
    "label": "Resposta alterada para uma opção sem presença"
  },
  {
    "key": "already_yes",
    "label": "Resposta com presença já registrada"
  },
  {
    "key": "already_no",
    "label": "Resposta sem presença já registrada"
  },
  {
    "key": "closed",
    "label": "Prazo do RSVP encerrado"
  },
  {
    "key": "invitation_expired",
    "label": "Convite expirado"
  },
  {
    "key": "unavailable",
    "label": "RSVP indisponível"
  },
  {
    "key": "invalid_invitation",
    "label": "Convite indisponível"
  },
  {
    "key": "needs_review",
    "label": "Resposta precisa de revisão"
  },
  {
    "key": "error",
    "label": "Resposta não registrada"
  },
  {
    "key": "uncertain",
    "label": "Resultado ainda não verificado"
  }
];
export const DEFAULT_RSVP_PRESENTATION = {
  "prompt": {
    "title": "Responder RSVP",
    "desc": "Selecione sua resposta.",
    "small": ""
  },
  "current_answer_label": "Resposta atual",
  "yes_label": "Sim",
  "no_label": "Não",
  "page": {
    "change_label": "Alterar resposta",
    "retry_label": "Tentar novamente"
  },
  "feedback": {
    "confirmed": {
      "title": "Resposta registrada",
      "desc": "Registramos sua resposta.",
      "small": ""
    },
    "declined": {
      "title": "Resposta registrada",
      "desc": "Registramos sua resposta.",
      "small": ""
    },
    "changed_yes": {
      "title": "Resposta atualizada",
      "desc": "Sua resposta anterior foi substituída.",
      "small": ""
    },
    "changed_no": {
      "title": "Resposta atualizada",
      "desc": "Sua resposta anterior foi substituída.",
      "small": ""
    },
    "already_yes": {
      "title": "Resposta já registrada",
      "desc": "Esta resposta já está registrada.",
      "small": "Você pode alterar sua resposta enquanto o convite estiver válido."
    },
    "already_no": {
      "title": "Resposta já registrada",
      "desc": "Esta resposta já está registrada.",
      "small": "Você pode alterar sua resposta enquanto o convite estiver válido."
    },
    "closed": {
      "title": "Prazo encerrado",
      "desc": "O período para responder a este RSVP terminou.",
      "small": "Sua resposta anterior, se houver, permanece registrada."
    },
    "invitation_expired": {
      "title": "Este convite expirou",
      "desc": "Não é possível responder usando este convite.",
      "small": "Solicite um convite atual ao organizador."
    },
    "unavailable": {
      "title": "RSVP indisponível",
      "desc": "Este RSVP está indisponível no momento.",
      "small": "Fale com o organizador se precisar de ajuda."
    },
    "invalid_invitation": {
      "title": "Convite indisponível",
      "desc": "Este convite não pode ser utilizado.",
      "small": "Solicite um convite atual ao organizador."
    },
    "needs_review": {
      "title": "Sua resposta precisa de revisão",
      "desc": "O organizador precisa revisar sua resposta antes de receber uma nova escolha.",
      "small": "Fale com o organizador."
    },
    "error": {
      "title": "Não foi possível registrar",
      "desc": "Sua nova resposta não foi registrada.",
      "small": "Tente novamente ou fale com o organizador."
    },
    "uncertain": {
      "title": "Verificando sua resposta",
      "desc": "A conexão foi interrompida e o resultado ainda não foi verificado.",
      "small": "Recarregue a resposta atual antes de tentar novamente."
    }
  }
};
const object = (value) => value && typeof value === "object" && !Array.isArray(value) ? value : {};
const textGroup = (value, fallback = {}) => Object.fromEntries(["title", "desc", "small"].map((key) => [key,
  String(object(value)[key] ?? (key === "desc" ? object(value).description : undefined) ?? fallback[key] ?? "").trim().slice(0, 500),
]));
export function normalizeRsvpContent(value) {
  const input = object(value), feedback = object(input.feedback);
  const legacy = { confirmed: input.confirmed, declined: input.declined, already_yes: input.already, already_no: input.already, closed: input.expirationDate, error: input.error };
  const pageFeedback = Object.fromEntries(RSVP_FEEDBACK_GROUPS.map(({key}) => [key, textGroup(feedback[key] ?? legacy[key], DEFAULT_RSVP_PRESENTATION.feedback[key])]));
  const whatsapp = object(input.whatsapp);
  return {
    prompt: textGroup(input.prompt, DEFAULT_RSVP_PRESENTATION.prompt),
    current_answer_label: String(input.current_answer_label ?? "Resposta atual").trim().slice(0, 120) || "Resposta atual",
    yes_label: String(input.yes_label ?? "Sim").trim().slice(0, 120) || "Sim",
    no_label: String(input.no_label ?? "Não").trim().slice(0, 120) || "Não",
    page: Object.fromEntries(Object.entries(DEFAULT_RSVP_PRESENTATION.page).map(([key, fallback]) => [key, String(object(input.page)[key] ?? fallback).trim().slice(0, 120) || fallback])),
    feedback: pageFeedback,
    whatsapp: {
      ...(whatsapp.feedback_translations !== undefined ? { feedback_translations: normalizeRsvpFeedbackTranslations(whatsapp.feedback_translations) } : {}),
      title: String(whatsapp.title ?? input.prompt?.title ?? DEFAULT_RSVP_PRESENTATION.prompt.title).trim().slice(0, 500),
      current_answer_label: String(whatsapp.current_answer_label ?? input.current_answer_label ?? "Resposta atual").trim().slice(0, 120) || "Resposta atual",
      feedback: Object.fromEntries(RSVP_FEEDBACK_GROUPS.map(({key}) => [key, textGroup(object(whatsapp.feedback)[key], pageFeedback[key])])),
    },
  };
}
export function normalizeSharedRsvpContent(value) {
  const content = normalizeRsvpContent(value);
  const feedback = { ...DEFAULT_RSVP_PRESENTATION.feedback, confirmed: content.feedback.confirmed, declined: content.feedback.declined, closed: content.feedback.closed,
    changed_yes: content.feedback.confirmed, already_yes: content.feedback.confirmed,
    changed_no: content.feedback.declined, already_no: content.feedback.declined };
  const feedbackTranslations = content.whatsapp.feedback_translations ?? normalizeRsvpFeedbackTranslations({ pt_BR: content.whatsapp.feedback });
  return { ...content, feedback, whatsapp: { title: "", current_answer_label: content.current_answer_label, feedback,
    feedback_translations: feedbackTranslations } };
}

export const formatRsvpFeedbackText = (presentation, outcome, { language = "pt_BR", answerLabel = "", includeAnswer = true } = {}) => {
  const content = normalizeRsvpContent(presentation);
  const locale = normalizeRsvpFeedbackLanguage(language) || "en_US";
  const key = rsvpFeedbackMessageKey(outcome);
  // Unlabelled legacy custom text is Portuguese; never reuse it for another language.
  const translations = content.whatsapp.feedback_translations ?? normalizeRsvpFeedbackTranslations({ pt_BR: content.whatsapp.feedback });
  const custom = ["confirmed", "declined", "closed"].includes(key) ? translations[locale]?.[key] : null;
  const feedback = custom && (custom.title || custom.desc) ? custom : defaultRsvpWhatsAppFeedback(locale, key);
  const answer = includeAnswer && ["confirmed", "declined"].includes(key) ? rsvpWhatsAppAnswerText(locale, answerLabel) : "";
  return [feedback.title, feedback.desc, feedback.small, answer].filter(Boolean).join("\n\n");
};
